package world.phantasmal.web.questEditor.models

/** Event-wave identity within a logical quest floor and map section. */
data class WaveModel(val id: Int, val floorId: Int, val sectionId: Int)
